import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";

const ROUTE_MAP = {
  "/api/legal-html/privacy": "/legal/privacy",
  "/api/legal-html/terms": "/legal/terms",
  "/api/legal-html/safety": "/legal/safety",
  "/api/legal-html/data-deletion": "/manage-data",
};

const components = {
  h1: ({ children }) => (
    <h2 className="mt-14 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">{children}</h2>
  ),
  h2: ({ children }) => (
    <h3 className="mt-10 font-display text-xl font-bold tracking-tight text-white sm:text-2xl">{children}</h3>
  ),
  h3: ({ children }) => (
    <h4 className="mt-8 font-display text-lg font-bold tracking-tight text-white">{children}</h4>
  ),
  p: ({ children }) => <p className="mt-4 text-sm leading-relaxed text-neutral-400 sm:text-base">{children}</p>,
  ul: ({ children }) => <ul className="mt-4 list-disc space-y-2.5 pl-6 text-sm leading-relaxed text-neutral-400 sm:text-base">{children}</ul>,
  ol: ({ children }) => <ol className="mt-4 list-decimal space-y-2.5 pl-6 text-sm leading-relaxed text-neutral-400 sm:text-base">{children}</ol>,
  strong: ({ children }) => <strong className="font-semibold text-white">{children}</strong>,
  code: ({ children }) => <code className="rounded bg-white/10 px-1.5 py-0.5 font-mono-plex text-[0.85em] text-neutral-200">{children}</code>,
  a: ({ children, href }) => {
    const to = ROUTE_MAP[href] || href;
    if (to && to.startsWith("/")) {
      return (
        <Link to={to} className="text-[#00F0FF] underline underline-offset-2">
          {children}
        </Link>
      );
    }
    return (
      <a href={to} className="text-[#00F0FF] underline underline-offset-2">
        {children}
      </a>
    );
  },
};

export const LegalMarkdown = ({ content }) => (
  <ReactMarkdown components={components}>{content}</ReactMarkdown>
);
